import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useWizard } from '../wizard/WizardContext';
import Icon from '../common/Icon';
import { ICONS } from '../../utils/fontAwesome';
import { trackPhotoDownload } from '../../utils/analytics';

const DownloadStep: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state, resetWizard } = useWizard();

  const handleDownload = () => {
    // Track photo download event
    if (state.selectedCountry) {
      trackPhotoDownload(state.selectedCountry.code);
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
        <div className="text-center space-y-6">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full">
            <Icon icon={ICONS.CHECK_CIRCLE} className="text-3xl text-green-600" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">{t('workflow.photoReady')}</h2>
            <p className="text-gray-600 dark:text-gray-300">{t('privacy.secureProcessing')}</p>
          </div>

          {/* Save Photo and Back to Edit buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={URL.createObjectURL(state.finalPhoto!)}
              download={`passport-photo-${state.selectedCountry!.code.toLowerCase()}.jpg`}
              onClick={handleDownload}
              className="bg-green-600 text-white px-8 py-4 rounded-lg hover:bg-green-700 transition-colors font-medium text-lg min-w-[160px]"
            >
              <Icon icon={ICONS.SAVE} className="mr-2" />
              Save Photo
            </a>
            <button
              onClick={() => navigate('/crop.html')}
              className="bg-blue-600 text-white px-8 py-4 rounded-lg hover:bg-blue-700 transition-colors font-medium text-lg min-w-[160px]"
            >
              <Icon icon={ICONS.EDIT} className="mr-2" />
              Back to Edit
            </button>
          </div>

          <img
            src={URL.createObjectURL(state.finalPhoto!)}
            alt="Passport ready for download"
            className="mx-auto border-2 border-gray-200 rounded-lg shadow-md"
            style={{
              width: `${Math.min(state.selectedCountry!.photo_width / 2, 300)}px`,
              height: `${Math.min(state.selectedCountry!.photo_height / 2, 400)}px`
            }}
          />

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={URL.createObjectURL(state.finalPhoto!)}
              download={`passport-photo-${state.selectedCountry!.code.toLowerCase()}.jpg`}
              onClick={handleDownload}
              className="bg-green-600 text-white px-8 py-4 rounded-lg hover:bg-green-700 transition-colors font-medium text-lg min-w-[160px]"
            >
              <Icon icon={ICONS.SAVE} className="mr-2" />
              Save Photo
            </a>
            <button
              onClick={() => {
                resetWizard();
                navigate('/');
              }}
              className="bg-blue-600 text-white px-8 py-4 rounded-lg hover:bg-blue-700 transition-colors font-medium text-lg min-w-[160px]"
            >
              <Icon icon={ICONS.SYNC} className="mr-2" />
              Create Another
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadStep;